import type { JSX } from "react";
import { Navigate } from "react-router-dom";

export default function AuthGuard({ children }: { children: JSX.Element }) {
  const token = localStorage.getItem("jwtToken");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
}